import { useEffect, useState } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navItems = [
    { label: "Product", href: "#product" },
    { label: "Features", href: "#features" },
    { label: "Showcase", href: "#showcase" },
    { label: "Docs", href: "#docs" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-black/70 backdrop-blur-md border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-8">
        <a href="/" className="flex items-center gap-2 cursor-pointer">
          <span
            className="text-white text-xl tracking-tight"
            style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 }}
          >
            Aurora
          </span>
        </a>


        <div className="hidden md:flex items-center gap-3">
          <a
            href="#login"
            className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
          >
            Sign in
          </a>
          <a
            href="#get-started"
            className="text-sm text-black bg-white hover:bg-white/90 transition-colors px-4 py-2 rounded-full cursor-pointer whitespace-nowrap font-medium"
          >
            Get started
          </a>
        </div>

        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          aria-label="Toggle menu"
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-black/90 backdrop-blur-md border-t border-white/10">
          <div className="px-4 py-4 flex flex-col gap-4">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="text-sm text-white/80 hover:text-white cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <div className="flex flex-col gap-2 pt-2 border-t border-white/10">
              <a
                href="#login"
                className="text-sm text-white/80 hover:text-white cursor-pointer"
              >
                Sign in
              </a>
              <a
                href="#get-started"
                className="text-sm text-black bg-white px-4 py-2 rounded-full text-center cursor-pointer whitespace-nowrap font-medium"
              >
                Get started
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}